// removed by extract-text-webpack-plugin
module.exports = {"component":"_2GzXb3oc1aEuoUnZ-7p3xt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/ModalDoubts/modalDoubts.css
// module id = 1264
// module chunks = 2